module.exports = __webpack_public_path__ + "static/media/12UNCTAD16.68f6c513.jpg";